import { render } from "./RiverControl.vue?vue&type=template&id=72d142b3&scoped=true"
import script from "./RiverControl.vue?vue&type=script&lang=js"
export * from "./RiverControl.vue?vue&type=script&lang=js"

import "./RiverControl.vue?vue&type=style&index=0&id=72d142b3&lang=css"
import "./RiverControl.vue?vue&type=style&index=1&id=72d142b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d142b3"]])

export default __exports__